export var PUSH = 'push';
export var REPLACE = 'replace';
export var PREFETCH = 'prefetch';
export var GO = 'go';
export default {
    PUSH: PUSH,
    REPLACE: REPLACE,
    GO: GO,
    PREFETCH: PREFETCH
};
